import { render, staticRenderFns } from "./SessionDayList.vue?vue&type=template&id=08220f5a"
import script from "./SessionDayList.vue?vue&type=script&lang=js"
export * from "./SessionDayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports